import { createContext, type ReactNode, useContext } from 'react';
import type { EmptyStateAction } from '@/components/empty-state/EmptyState';

/**
 * Set by `AccountDashboard` while the wallet is disconnected or not signed in (A-2222). A `TerminalTableScaffold`
 * inside it renders this as an `EmptyState` (table surface) instead of its empty copy and hides its footer, and the
 * tables' bulk actions disable themselves.
 */
export interface TableEmptyStateOverride {
  body: ReactNode;
  action: EmptyStateAction;
}

const TableEmptyStateContext = createContext<TableEmptyStateOverride | null>(null);

export const TableEmptyStateProvider = TableEmptyStateContext.Provider;

export function useTableEmptyState(): TableEmptyStateOverride | null {
  return useContext(TableEmptyStateContext);
}
